import * as React from 'react'
import { BPMAnalyticsAPI } from '../../../api'
import { Series, ArgumentAxis, Label, ConstantLine, ValueAxis } from 'devextreme-react/chart'
import { resultDateTransformer } from '../../../utils/date'
import { StatisicChart } from '../../../components/StatisticChart'

export const StreamStatisticChart: React.FunctionComponent<{ album: string }> = ({ album }) => {
    const [avg, setAvg] = React.useState(0)
    return (
        <StatisicChart subtitle='Streams'
            onRequestLoad={(options, signal) => {
                return resultDateTransformer(BPMAnalyticsAPI.get<any>('album/streams', options, signal)).then((d) => {
                    return new Promise((solve) => {
                        const total = d.reduce((a, b) => a + b.count, 0)
                        const avg = total / d.length
                        solve({ total, data: d })
                        setAvg(avg)
                    })
                })
            }} additionalParams={{ groupDateBy: 'day', album }}>
            <Series
                valueField="count"
                argumentField="date"
                color={'white'}>
            </Series>
            <ArgumentAxis>
                <Label format="day" indentFromAxis={1} />
            </ArgumentAxis>
            <ValueAxis label={{ visible: false }} >
                <ConstantLine width={2}
                    value={avg.toFixed(0)}
                    color={'#fff'} label={{ visible: false }}
                    dashStyle="dash">
                </ConstantLine>
            </ValueAxis>
        </StatisicChart>
    )
}


// WEBPACK FOOTER //
// ./src/pages/Album/charts/StreamStatisticChart.tsx